export default "__VITE_ASSET__4Hb5XIzW__"